export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ09.147c0610.mp3";